export default { 
    'PPTedit.Saved':'保存于：',
    'PPTedit.end':'到底啦',
    'PPTedit.play':'播 放',
    'PPTedit.avatar':'形象',
    'PPTedit.InputPlaceholder':'请输入演讲内容',
    'PPTedit.share': '分享'
}